module.exports = __webpack_public_path__ + "img/logo-fundacion-forge.b02e1b23.png";